(function () {
  function capture(name, properties) {
    if (!window.posthog || typeof window.posthog.capture !== 'function') return;
    window.posthog.capture(name, properties || {});
  }

  function identifyMarketingSubscriber(email, source) {
    if (!email || !window.posthog || typeof window.posthog.identify !== 'function') return;
    window.posthog.identify(email.toLowerCase(), {
      $email: email.toLowerCase(),
      email_consent: true,
      email_consent_source: source
    });
    capture('lockd_marketing_signup_completed', {
      source: source,
      path: window.location.pathname
    });
  }

  window.LockdAnalytics = {
    capture: capture,
    identifyMarketingSubscriber: identifyMarketingSubscriber
  };

  var params = new URLSearchParams(window.location.search);
  var chainCode = (params.get('c') || '').trim().toUpperCase();
  if (window.location.pathname === '/pages/claim' && chainCode) {
    capture('lockd_qr_opened', {
      chain_code_suffix: chainCode.slice(-4),
      path: window.location.pathname
    });
  }

  try {
    var visitKey = 'lockd_visit_count';
    var visitCount = parseInt(window.localStorage.getItem(visitKey) || '0', 10) + 1;
    window.localStorage.setItem(visitKey, String(visitCount));
    if (visitCount > 1) {
      capture('lockd_repeat_visit', {
        visit_number: visitCount,
        path: window.location.pathname
      });
    }
  } catch (error) {
    // Storage can be unavailable in privacy modes; analytics should remain non-blocking.
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!(form instanceof HTMLFormElement)) return;

    if (form.matches('form[action*="/cart/add"]')) {
      capture('lockd_add_to_cart_submit', {
        path: window.location.pathname,
        product_form: true
      });
    }

    if (form.matches('form[action*="/contact"]') || form.querySelector('input[name="contact[email]"]')) {
      capture('lockd_form_submit', {
        path: window.location.pathname,
        form_type: form.querySelector('input[name="contact[tags]"]') ? form.querySelector('input[name="contact[tags]"]').value : 'contact'
      });
    }

    if (event.submitter && event.submitter.name === 'checkout') {
      capture('lockd_checkout_click', {
        path: window.location.pathname
      });
    }

    if (form.matches('.chain-code-form')) {
      var codeInput = form.querySelector('input[name="c"]');
      var lookupCode = codeInput ? codeInput.value.trim().toUpperCase() : '';
      capture('lockd_code_lookup_started', {
        chain_code_suffix: lookupCode.slice(-4),
        path: window.location.pathname
      });
    }
  }, true);

  document.addEventListener('click', function (event) {
    var target = event.target.closest('a, button');
    if (!target) return;
    var label = (target.textContent || '').trim().slice(0, 80);
    if (/Lockd Someone|Shop 5 Pack|Checkout|Join Drop|Finish checkout/i.test(label)) {
      capture('lockd_cta_click', {
        label: label,
        href: target.href || null,
        path: window.location.pathname
      });
    }
  });

  if (window.location.pathname.indexOf('/products/') === 0) {
    capture('lockd_product_view', {
      path: window.location.pathname,
      title: document.title
    });
  }
})();
